import { render, staticRenderFns } from "./MoreButton.vue?vue&type=template&id=7f370079&scoped=true&"
import script from "./MoreButton.vue?vue&type=script&lang=js&"
export * from "./MoreButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f370079",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f370079')) {
      api.createRecord('7f370079', component.options)
    } else {
      api.reload('7f370079', component.options)
    }
    module.hot.accept("./MoreButton.vue?vue&type=template&id=7f370079&scoped=true&", function () {
      api.rerender('7f370079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/MoreButton.vue"
export default component.exports